require("./src/bundles/styles/Styles.css");
require("./src/scss/global.scss");
 
exports.onClientEntry = () => {
  if (window.location.pathname === "/") {
    window.location.replace("/products/");
  }

  const script1 = document.createElement("script");
  script1.src = "https://js.adsrvr.org/up_loader.1.1.0.js";
  script1.type = "text/javascript";
  script1.onload = function () {
    const script2 = document.createElement("script");
    script2.type = "text/javascript";
    script2.innerHTML = `
      ttd_dom_ready(function() {
        if (typeof TTDUniversalPixelApi === 'function') {
          var universalPixelApi = new TTDUniversalPixelApi();
          universalPixelApi.init("16pf9jt", ["32rj1sy"], "https://insight.adsrvr.org/track/up");
        }
      });
    `;
    document.body.appendChild(script2);
  };
  document.body.appendChild(script1);
};